import { useEffect, useState } from "react";
import { Star } from "lucide-react";

export const CommentWall = () => {
  const [items, setItems] = useState([]);
  const [i, setI] = useState(0);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/demo/comments/wall`)
      .then((r) => r.json())
      .then((d) => setItems(d.comments || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setI((x) => (x + 1) % items.length), 5000);
    return () => clearInterval(t);
  }, [items.length]);

  if (!items.length) return null;
  return (
    <div className="mt-8 max-w-xl" data-testid="comment-wall">
      <div key={i} className="rounded-xl border border-white/10 bg-white/5 backdrop-blur px-5 py-4" style={{ animation: "wallFade 600ms ease-out both" }}>
        <span className="flex items-center gap-0.5" aria-label="5 star rating">
          {[0, 1, 2, 3, 4].map((k) => <Star key={k} className="h-3.5 w-3.5 fill-[#ffc53d] text-[#ffc53d]" />)}
        </span>
        <p className="text-sm text-slate-200 mt-2 leading-relaxed" data-testid="comment-wall-quote">“{items[i].comment}”</p>
        <p className="text-[11px] text-slate-500 mt-1.5">— a demo viewer</p>
      </div>
      <style>{`@keyframes wallFade { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }`}</style>
    </div>
  );
};
